const { Component } = wp.element;

const alias = 'AZON-country-list'

class AZON_Country_Dropdown extends Component {

  constructor(props) {
    super(props);

    this.state = {
      dropdown_state: false,
      current_value: false
    }
  }

  buildListHtml()
  {
    const self = this

    const { list } = this.props
    const { dropdown_state } = this.state

    const list_html = list.map( (__list, value) => {
      return <li onClick={ self.setValue.bind(self, __list) } key={ __list.alias }><img src={ window.WooZoneNoAwsKeysImport.assets_url + __list.flag } /><span>{ __list.label }</span></li>
    })

    return <ul style={{ display: ( dropdown_state ? "block" : "none" ) }}>{ list_html }</ul>
  }

  printDefaultValue()
  {
    const self = this
    let { list, defaultValue } = this.props
    const { current_value } = this.state

    if( current_value != false && current_value != defaultValue ){
      defaultValue = current_value;
    }

    return list.map( (__list) => {
      if( __list.alias == defaultValue ){
        return <span onClick={ self.toggleDropdown.bind(self) } key={ __list.alias } className={ alias + "-default" }><img src={ window.WooZoneNoAwsKeysImport.assets_url + __list.flag } /><span>{__list.label}</span></span>;
      }
    })
  }

  setValue( value )
  {
    this.setState({ 
      current_value: value.alias,
      dropdown_state: false
    });

    // update parent props
    this.props.onChange( value.alias );
  }

  toggleDropdown()
  {
    this.setState({ 
      dropdown_state: !this.state.dropdown_state
    });
  }

  render() {

    const { list } = this.props

    if( !list ){
      return <p>No list provided!</p>
    }

    return <div className={ alias + "-wrapper" }>
      { this.printDefaultValue() }
      { this.buildListHtml() }
    </div>
  }
}

export { AZON_Country_Dropdown };